// extracted by mini-css-extract-plugin
export var customersText = "index-module--customersText--DRHfO";
export var customersList = "index-module--customersList--q9Emj";
export var customersList__item = "index-module--customersList__item--O+GnW";